var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 2.1a6.9 6.9 0 1 0 0 13.8A6.9 6.9 0 0 0 9 2.1M.9 9a8.1 8.1 0 1 1 16.2 0A8.1 8.1 0 0 1 .9 9m6.875-.625a.6.6 0 0 1 .6-.6H9a.6.6 0 0 1 .6.6v3.775h.025a.6.6 0 1 1 0 1.2H9a.6.6 0 0 1-.6-.6V8.975h-.025a.6.6 0 0 1-.6-.6M9.78 5.563a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0"
  })));
};
export default SvgInfoIcon;